<template>
    <div class="m-3">
        <b-button block v-b-toggle.competition-map>Where I've Competed</b-button>
        <b-collapse id="competition-map" visible>
            <b-card>
                <b-aspect aspect="16:9">
                    <div style="height: 100%; width: 100%;">
                        <LMap
                            @ready="mapReady"
                            :style="{ maxWidth: '1200px', margin: '0 auto'}"
                            :zoom="zoomLevel"
                            :center="mapCenter"
                            :options="{ maxZoom: 18, zoomControl: true }">
                            <LTileLayer :url="url" :attribution="attribution" />
                            <LMarker v-for="coord in coords"
                                :key="coord.id"
                                :lat-lng="coord.latLng">
                                <LTooltip>{{coord.tooltip}}</LTooltip>
                            </LMarker>
                        </LMap>
                    </div>
                </b-aspect>
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LTooltip } from "vue2-leaflet";

export default {
    data() {
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: "&copy; <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
            mapCenter: [0, 0]
        }
    },
    props: ["results"],
    computed: {
        coords() {
            return this.results.map(x => {
                return {
                    id: x.id,
                    latLng: latLng(x.coords.lat, x.coords.long),
                    tooltip: x.location
                };
            });
        },
        computedZoomLevel() {
            // Determine zoom level based on screen width
            return window.innerWidth <= 768 ? 0 : 2; // 2 for mobile, 3 for desktop
        }
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LTooltip
    },
    methods: {
        mapReady(map) {
            map.fitWorld();
        }
    }
}
</script>